import { assert } from "@glideapps/ts-necessities";
import { useWireAppTheme } from "hooks/use-wireapp-theme";
import tw from "twin.macro";
import { getSpinner } from "webapp/chrome/views/activity-spinner/activity-spinner";
import { css } from "webapp/styled-components";
import type { BaseProps } from "../custom-sign-in-props";
import type { PagesLoginSource } from "./wire-email-input";
import { WireEmailInput } from "./wire-email-input";

interface Props extends BaseProps {
    readonly pagesSource?: PagesLoginSource;
    readonly onPageSourceChanged?: (newPageSource: PagesLoginSource) => void;
}

export const CustomWireSignIn: React.FunctionComponent<Props> = p => {
    const theme = useWireAppTheme();

    const { loginType, currentState, previewMode, appTitle, pagesSource } = p;

    // These are not supported in pages
    assert(loginType !== "none" && loginType !== "password");

    const content =
        currentState === "sign-in" ? (
            <div
                tw="flex justify-center items-center self-center margin-top[80px] min-height[200px] margin-bottom[80px]"
                className="spinner">
                {getSpinner(theme.n0, "loading-placeholder")}
            </div>
        ) : (
            <div tw="flex flex-col items-center">
                {pagesSource === "main-sign-in" && (
                    <div tw="text-2xl font-extrabold mb-10 text-bg-front">{appTitle}</div>
                )}
                <div
                    className={pagesSource}
                    tw="bg-bg-front p-12 pt-10 rounded-xl"
                    css={css`
                        &.main-sign-in {
                            ${tw`shadow-2xl width[320px]
                              gp-md:(width[465px])`}
                        }
                        &.modal-sign-in,
                        &.modal-sign-up {
                            ${tw`width[465px]`}
                        }
                    `}>
                    {loginType === "email" && <WireEmailInput theme={theme} {...p} />}
                </div>
            </div>
        );

    return (
        <div
            css={
                previewMode
                    ? css`
                          ${tw`pointer-events-none`}
                      `
                    : undefined
            }
            role="dialog"
            aria-modal={true}
            aria-labelledby="sign-in-description">
            {content}
        </div>
    );
};
